<template>
  <div>
    <v-snackbar
      v-model="localShow"
      color="#3ea56e"
      right
      :timeout="timeout"
    >
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="closeSnackBar">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
  </div>
</template>
<script>
export default {
  props: ["msg", "showSnackBar"],
  data() {
    return {
      timeout: 5000,
    };
  },
  computed: {
    localShow: {
      get() {
        return this.showSnackBar;
      },
      set(val) {
        if (!val) {
          this.$emit("stepper", {
            showSnackBar: false,
          });
        }
      },
    },
  },
  methods: {
    closeSnackBar() {
      this.$emit("stepper", {
        showSnackBar: false,
      });
    },
  },
};
</script>